const arquivoHelper = {
    PROPOSTA: 1,
    APOLICE: 2,
    OUTROS: 3,
    PROPOSTA_ASSINADA: 4,
    DECLARACAO_SEGURO: 5
  };
  
export default arquivoHelper;


// WEBPACK FOOTER //
// ./src/helpers/arquivo-helper.js